// Build-time configuration only
export const environment = {
	production: true,
	isMockEnabled: false,
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	// Temporary: These will be removed once all services use ConfigService
	host: 'prod',
	region: 'us-west-2',
	bucket: 'vendibean-updates',
	roles: ['sadmin', 'admin', 'rmgr', 'disti']
};
